import { TrackingPopoverDelayKind } from "@ryde/shared";

/** Which styling the tracking popup's time cell gets for a given delay. */
export const getTrackingDelayValueClass = (
  kind: TrackingPopoverDelayKind,
): string => {
  if (kind === "late") {
    return "time-cell__value time-cell__value--late";
  }

  if (kind === "early") {
    return "time-cell__value time-cell__value--early";
  }

  return "time-cell__value time-cell__value--muted";
};
